__turbopack_context__.v({
  "layout": "RepairDetailsShell-module-scss-module__1XJuEW__layout",
  "layoutNoSidebar": "RepairDetailsShell-module-scss-module__1XJuEW__layoutNoSidebar",
  "layoutSidebarEnd": "RepairDetailsShell-module-scss-module__1XJuEW__layoutSidebarEnd",
  "mainColumn": "RepairDetailsShell-module-scss-module__1XJuEW__mainColumn",
  "shell": "RepairDetailsShell-module-scss-module__1XJuEW__shell",
  "sidebar": "RepairDetailsShell-module-scss-module__1XJuEW__sidebar",
  "sidebarEnd": "RepairDetailsShell-module-scss-module__1XJuEW__sidebarEnd",
});
